import { React, createContext, useState, useContext, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { ApiService } from '../ApiService';
import { useProovedorData } from "./ProovedorData";


const AppContext = createContext();
export const useProveedorCompany = () => useContext(AppContext);

export const ProveedorCompany = ({ children }) => {
    const { nit } = useParams();
    const parametros = useParams();

    const { main_data, loadImageS, dbData, data_user } = useProovedorData();
    const navigate = useNavigate();

    /////////////////////////STATES///////////////////////////////////
    const [currentCompany, setCurrentCompany] = useState({
        authCode: null,
        nameComany: "Cargando Nombre...",
        logo: null,
        logo_catalogo: null,
        theme: "#989d96",
        description: '',
        country_origin: null,
        nit: 0
    });

    const [currentBranch, setCurrentBranch] = useState({
        key_branch: null,
        fullName: "Cargando Sucursal...",
        code: null, //roll
        phone: 0,
        location_url: null,
        lat: null,
        lon: null,
        day_ini: null,
        day_Fin: null,
        time_range: null,
        particular_day: null,
        particular_time: null,
        type: null,
        description: '',
        currency: 'USD'
    });

    const [shortListProducts, setShortListProducts] = useState([]);

    const [arrayBranchs, setArrayBranchs] = useState([]);

    const [showTable, setShowTable] = useState(true);

    const [historyProducts, setHistoryProducts] = useState({});
    //////////////////////END STATES///////////////////////////////////

    async function loadBranchs(company) {
        if (company?.authCode == null && currentCompany?.authCode == null) return;

        const data = await ApiService.fetchData(`api/company/branch/list?key_company=${company?.authCode ?? currentCompany?.authCode}`);

        if (!data || Number(data?.code) > 400) {
            navigate("/");
            return;
        }

        setArrayBranchs(data);
        setCurrentBranch(data[0] || {});
    }

    const returnCurrency = (price = '0.00', type = null, onlyPrice = false) => {
        const numValue = parseFloat(price);
        if (isNaN(numValue)) return "";

        if (onlyPrice) {
            return new Intl.NumberFormat('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(numValue);
        }

        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: type ?? currentBranch?.currency
        }).format(numValue);
    }

    useEffect(() => {
        // console.log(`Se cargo empresa(${nit}):\n`, main_data, data_user);
        if (main_data?.companys && (main_data?.companys ?? []).length > 0) {
            const findCompany = (main_data?.companys ?? []).find((objs) => objs?.nit == nit);

            if (!findCompany) navigate("/");
            setCurrentCompany(findCompany);

            const root = document.documentElement;
            root.style.setProperty('--theme-company', findCompany?.theme ?? '#989d96');

            loadBranchs(findCompany);
        }
    }, [nit, main_data?.companys]);

    return (
        <AppContext.Provider value={{
            nit,
            currentCompany,
            arrayBranchs,
            currentBranch,
            setCurrentBranch,
            setArrayBranchs,
            setCurrentCompany,
            loadImageS,
            dbData,
            showTable,
            setShowTable,
            returnCurrency,
            historyProducts,
            setHistoryProducts,
            shortListProducts,
            setShortListProducts
        }}>
            {children}
        </AppContext.Provider>
    )
}
